import { forwardRef, type ReactNode, type UIEvent, } from "react";
import styled from "styled-components";



export declare type ScrollableProps = {
	children: ReactNode;
	height?: string;
	onScroll?: (event: UIEvent<HTMLDivElement>) => void;
}



export const Scrollable = forwardRef<HTMLDivElement, ScrollableProps>(({ children, height, onScroll, }, ref) => {
	return (
		<ScrollableContainer height={height} onScroll={onScroll} ref={ref}>
			{children}
		</ScrollableContainer>
	);
});

Scrollable.displayName = "Scrollable";



const ScrollableContainer = styled.div<{ height?: string }>`
	flex: 1;
	min-height: 0;
	overflow-y: auto;
	width: 100%;

	&::-webkit-scrollbar {
		width: 6px;
		background-color: transparent;
	}

	&::-webkit-scrollbar:hover {
		background-color: #03FF8F11;
	}

	&::-webkit-scrollbar-track {
		background-color: transparent;
	}

	&::-webkit-scrollbar-thumb {
		cursor: pointer;
		background-color: #30372F;
		border-radius: 3px;
	}

	&::-webkit-scrollbar-thumb:hover {
		background: var(--primary) !important;
	}
`;

